import Layout from '@/layouts/BasicLayout/index.vue'
import type { RouteRecordRaw } from 'vue-router'
import FrameBlank from '@/layouts/FrameBlank.vue'
import { MENU_LABEL, ROUTE_ROLE_TYPE_NAME } from '@/router/menuHelper/constants'

const BOTH = [ROUTE_ROLE_TYPE_NAME.FIRST_MONEY_BOTH, ROUTE_ROLE_TYPE_NAME.MONEY_TREE_ONLY]

const link: RouteRecordRaw = {
  path: '/center-selft-settlement',
  name: 'LeyopaySettlement',
  component: Layout,
  meta: {
    orderNo: 1000,
    icon: 'ion:tv-outline',
    title: MENU_LABEL.LEYOPAY,
    module: 'SettlementSystem',
    menuOfRoleType: BOTH
  },
  children: [
    // {
    //   path: '/cash-withdrawal',
    //   name: 'CashWithdrawal',
    //   component: FrameBlank,
    //   meta: {
    //     title: '资金申请提现',
    //     openInNewWindow: true,
    //     menuOfRoleType: BOTH,
    //     path: '/cash-withdrawal',
    //     module: 'SettlementSystem'
    //   }
    // },
    // {
    //   path: '/invoice-manage',
    //   name: 'InvoiceManage',
    //   component: FrameBlank,
    //   meta: {
    //     title: '发票管理(实销实结)',
    //     path: '/invoice-manage',
    //     menuOfRoleType: BOTH,
    //     openInNewWindow: true,
    //     module: 'SettlementSystem'
    //   }
    // },
    // {
    //   path: `/cash-cow-profits-view`,
    //   name: 'CashCowProfitsView',
    //   component: FrameBlank,
    //   meta: {
    //     title: 'YQS利润查看',
    //     path: '/cash-cow-profits-view',
    //     menuOfRoleType: BOTH,
    //     openInNewWindow: true,
    //     module: 'SettlementSystem'
    //   }
    // }
  ]
}

export default link
